import { DateFormatter } from '@components'

import { InternalAccessor, Link, TableColumn, Text } from '@billy/design-system'
import { TFunction } from 'i18next'

import { AuditTrailTableAccessor } from '../../enums/AuditTrailTableAccessor'
import { AuditTrailGroupItemType } from '../../types/AuditTrail'
import { AuditTrailTableRow } from '../../types/AuditTrailTableRow'
import { TaxRateField } from './elements/TaxRateField'
import { TransactionLink } from './elements/TransactionLink'

interface TableColumnsProps {
  t: TFunction
  type: AuditTrailGroupItemType
}

export const TableColumns = ({ t, type }: TableColumnsProps): TableColumn<AuditTrailTableRow>[] => [
  {
    accessor: AuditTrailTableAccessor.Transaction,
    Header: '#',
    Cell: ({ value: { transaction, transactionId } }) => (
      <TransactionLink transaction={transaction} transactionId={transactionId} />
    ),
    size: 'xxs',
  },
  {
    accessor: AuditTrailTableAccessor.Date,
    Header: t('audit_trail.table.header.date'),
    Cell: ({ value }) => {
      return value ? <DateFormatter value={value} /> : <Text>-</Text>
    },
    maxWidth: 70,
  },
  {
    accessor: AuditTrailTableAccessor.Voucher,
    Header: t('audit_trail.table.header.voucher'),
    Cell: ({ value }) => <Text>{value}</Text>,
    maxWidth: 40,
  },
  {
    accessor: AuditTrailTableAccessor.Description,
    Header: t('audit_trail.table.header.description'),
    Cell: ({ value: { description, url } }) => (
      <Link href={url} target="_blank" withAnimation>
        {description}
      </Link>
    ),
    size: 'm',
    truncate: true,
  },
  ...(type === 'account'
    ? [
        {
          accessor: AuditTrailTableAccessor.NetAmount,
          Header: t('audit_trail.table.header.net_amount'),
          Cell: ({ value }) => <Text alignment="right">{value}</Text>,
          size: 'xs',
          alignment: 'right',
        } as TableColumn<AuditTrailTableRow>,
      ]
    : []),
  ...(type === 'account'
    ? [
        {
          accessor: AuditTrailTableAccessor.Rate,
          Header: t('audit_trail.table.header.rate'),
          Cell: ({ value: { rate, name, description } }) => (
            <TaxRateField rate={rate} name={name} description={description} />
          ),
          alignment: 'right',
          size: 'xs',
        } as TableColumn<AuditTrailTableRow>,
      ]
    : []),
  {
    accessor: AuditTrailTableAccessor.Amount,
    Header: t('audit_trail.table.header.amount'),
    Cell: ({ value: { amount, isVoided } }) => <Text strikethrough={isVoided}>{amount}</Text>,
    size: 'xs',
    alignment: 'right',
  },
  {
    accessor: AuditTrailTableAccessor.Balance,
    Header: t('audit_trail.table.header.balance'),
    Cell: ({ value }) => <Text>{value}</Text>,
    size: 'xs',
    alignment: 'right',
  },
  {
    accessor: InternalAccessor.Disabled,
  },
]
